import "core-js/modules/es6.string.trim";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.object.define-property";

/** @hidden */
var ShaderCodeCursor =
/** @class */
function () {
  function ShaderCodeCursor() {}

  Object.defineProperty(ShaderCodeCursor.prototype, "currentLine", {
    get: function get() {
      return this._lines[this.lineIndex];
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(ShaderCodeCursor.prototype, "canRead", {
    get: function get() {
      return this.lineIndex < this._lines.length - 1;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(ShaderCodeCursor.prototype, "lines", {
    set: function set(value) {
      this._lines = [];

      for (var _i = 0, value_1 = value; _i < value_1.length; _i++) {
        var line = value_1[_i]; // Prevent removing line break in macros.

        if (line[0] === "#") {
          this._lines.push(line);

          continue;
        }

        var split = line.split(";");

        for (var index = 0; index < split.length; index++) {
          var subLine = split[index];
          subLine = subLine.trim();

          if (!subLine) {
            continue;
          }

          this._lines.push(subLine + (index !== split.length - 1 ? ";" : ""));
        }
      }
    },
    enumerable: true,
    configurable: true
  });
  return ShaderCodeCursor;
}();

export { ShaderCodeCursor };